import { render, staticRenderFns } from "./WidgetsItemHome.vue?vue&type=template&id=4657fe0d&"
import script from "./WidgetsItemHome.vue?vue&type=script&lang=js&"
export * from "./WidgetsItemHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports